import * as _numeral from 'numeral';

export const numeral = _numeral;
